import BeSafeMultiInput from 'components/commons/BeSafeMultiInput';
import React from 'react';

const AdvancedFilterMultiInputFilter = ({ onChange, values, filterKey }) => {
  return (
    <div className="d-flex justify-content-center p-3">
      <BeSafeMultiInput
        onChange={onChange}
        selectedItems={values}
        items={values}
        filterType={filterKey}
        inputEnabled
      />
    </div>
  );
};

export default AdvancedFilterMultiInputFilter;
